/**
 * Returns data of clicked Bar
 *
 * @param {object} event click chart event
 * @returns {object} chart, yValue, dataset of bar, xLabelValue
 */

export default function getBarData(event) {
  const chart = this
  const activePoint = chart.getElementAtEvent(event)[0]

  const isUndefinedIndex = typeof activePoint._datasetIndex === 'undefined'
  const isNaNIndex = isNaN(activePoint._datasetIndex)

  if (!isUndefinedIndex && !isNaNIndex) {
    const dataset = chart.data.datasets[activePoint._datasetIndex]
    const xLabelValue = activePoint._model.label
    const yValue = dataset.data[activePoint._index]

    return {
      chart,
      yValue,
      dataset,
      xLabelValue,
    }
  }
}
